import {
  Dialog,
  DialogContent,
  DialogOverlay,
  DialogPortal
} from '@components/ui/dialog';
import React from 'react';

const Modal = ({ open, onOpenChange, children }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay className="fixed inset-0 z-50 backdrop-blur-sm bg-black/50 animate-in fade-in" />
        <DialogContent
          className={`fixed top-1/2 left-1/2 z-50 p-6 w-full !max-w-2xl bg-white rounded-2xl shadow-xl -translate-x-1/2 -translate-y-1/2 animate-in zoom-in-95`}
        >
          {children}
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};

export default Modal;
